/**
 * 旅行者（被保険者）情報
 */
export class TravelerInfo {
	// public 変数	-----------------------------------------------------------
	private m_RomanName: string = null  // 旅行者名（ローマ字）
	private m_RomanLastName: string = null  // 旅行者名（姓・ローマ字）
	private m_RomanFirstName: string = null  // 旅行者名（名・ローマ字）
	private m_DateOfBirth: Date = null // 生年月日
	private m_Year: string = null; // 年
	private m_Month: string = null; // 月
	private m_Date: string = null; // 日
	private m_Gender: string = null; // 性別
	private m_Recipient: string = null; // 死亡保険金受取人
	// ------------------------------------------------------------------------

	// プロパティ  ---------------------------------------------------------------
	/** 契約者名（ローマ字） */
	public get romanName(): string { return this.m_RomanName; } public set romanName(romanName: string) { this.m_RomanName = romanName; }
	/** 旅行者名（姓・ローマ字） */
	public get romanLastName(): string { return this.m_RomanLastName; } public set romanLastName(romanLastName: string) { this.m_RomanLastName = romanLastName; }
	/** 旅行者名（名・ローマ字） */
	public get romanFirstName(): string { return this.m_RomanFirstName; } public set romanFirstName(romanFirstName: string) { this.m_RomanFirstName = romanFirstName; }
	/** 生年月日 */
	public get dateOfBirth(): Date { return this.m_DateOfBirth; } public set dateOfBirth(dateOfBirth: Date) { this.m_DateOfBirth = dateOfBirth; }
	/** 年 */
	public get year(): string { return this.m_Year; } public set year(year: string) { this.m_Year = year; }
	/** 月 */
	public get month(): string { return this.m_Month; } public set month(month: string) { this.m_Month = month; }
	/** 日 */
	public get date(): string { return this.m_Date; } public set date(date: string) { this.m_Date = date; }
	/** 性別 */
	public get gender(): string { return this.m_Gender; } public set gender(gender: string) { this.m_Gender = gender; }
	/** 死亡保険金受取人 */
	public get recipient(): string { return this.m_Recipient; } public set recipient(recipient: string) { this.m_Recipient = recipient; }
	// --------------------------------------------------------------------------

	// コンストラクタ --------------------------------------------------------
	constructor() { }
	// ------------------------------------------------------------------------
}
